import { useTable } from "react-table";
import { useState, useEffect } from 'react'
// Create an editable cell renderer
const EditableCell = ({
    value: initialValue,
    row: { index },
    column: { id },
    updateMyData, // This is a custom function that we supplied to our table instance
}) => {
    // We need to keep and update the state of the cell normally
    const [value, setValue] = useState(initialValue)

    const onChange = e => {
        setValue(e.target.value)
    }

    // We'll only update the external data when the input is blurred
    const onBlur = () => {
        updateMyData(index, id, value)
    }

    // If the initialValue is changed external, sync it up with our state
    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    return <input value={value} onChange={onChange} onBlur={onBlur} />
}

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
    Cell: EditableCell,
}


const DataTable = ({ columns, data, tableHeight, tableClassName, updateMyData }) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data, defaultColumn, updateMyData });

    if (tableHeight === undefined)
        tableHeight = 500;

   

    return (
        <div style={{ height: `${tableHeight}px`, overflowY: 'scroll', borderTopWidth: '1px', borderTopStyle: 'solid', borderTopColor:'#e8e8f7 ' }}>
            <table className={`table table-hover table-bordered table-vcenter tx-11 mb-0 ${tableClassName}`} {...getTableProps()} style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}
                            style={{ position: 'sticky', top: -1, background: '#f0f2f8', zIndex: 1}}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps({
                                    className: column.className
                                })} style={{ borderBottom: '1px solid #ddd' }}>
                                    {column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map(row => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}  style={{ borderBottom: '1px solid #ddd' }}>
                                {row.cells.map(cell => (
                                    <td {...cell.getCellProps({
                                        className: cell.column.className
                                    })}>
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;